import { PropsWithChildren, useEffect } from 'react';

type PendoConfig = {
  apiKey: string;
};

const PendoProvider = ({
  children,
  config
}: PropsWithChildren<{ config: PendoConfig }>) => {
  useEffect(() => {
    (function (apiKey) {
      function initPendo(p: any, e: any, n: any, d: any, o: any) {
        let v, w, x, y, z;
        o = p[d] = p[d] || {};
        o._q = o._q || [];
        // eslint-disable-next-line prefer-const
        v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
        for (w = 0, x = v.length; w < x; ++w)
          (function (m) {
            o[m] =
              o[m] ||
              function () {
                o._q[m === v[0] ? 'unshift' : 'push'](
                  // eslint-disable-next-line prefer-rest-params
                  [m].concat([].slice.call(arguments, 0))
                );
              };
          })(v[w]);
        // eslint-disable-next-line prefer-const
        y = e.createElement(n);
        y.async = !0;
        y.src = 'https://cdn.eu.pendo.io/agent/static/' + apiKey + '/pendo.js';
        // eslint-disable-next-line prefer-const
        z = e.getElementsByTagName(n)[0];
        z.parentNode.insertBefore(y, z);
      }

      initPendo(window, document, 'script', 'pendo', {});
    })(config.apiKey);
  }, [config.apiKey]);

  return <>{children}</>;
};

export { PendoProvider };
